<template>
  <div>
    <reciepeDetails :reciepe_id="reciepe_id"></reciepeDetails>
  </div>
</template>

<script>
// @ is an alias to /src
import reciepeDetails from "@/components/reciepeDetails.vue";

export default {
  name: "Reciepe",
  data: function() {
    return {
      reciepe_id: parseInt(this.$route.params.reciepe_id)
    };
  },
  components: {
    reciepeDetails
  }
};
</script>
